import React from 'react';
import { Stack, Text, ToggleGroup } from 'library/ui';
import { JobDetailOption, JobDetailValue, JobDetailValueWithOption, QualificationOption } from 'models';

export default function MultiSelect({
    options,
    selectedOptions,
    onSelect,
}: {
    options: QualificationOption[] | JobDetailOption[];
    selectedOptions?: JobDetailValueWithOption[] | JobDetailValue[];
    onSelect: (optionId: number) => void;
}) {
    const selectedValues = (selectedOptions ?? [])
        .map((val) => val.option_id)
        .filter((id): id is number => id != null)
        .map(String);

    function onToggle(newValues: string[]) {
        const added = newValues.find((value) => !selectedValues.includes(value));
        const removed = selectedValues.find((value) => !newValues.includes(value));
        const changed = added ?? removed;
        if (changed !== undefined) {
            onSelect(Number(changed));
        }
    }

    return (
        <Stack gap="sm">
            <Text size="sm" tone="secondary">
                Select all that apply.
            </Text>
            <ToggleGroup
                multi
                options={options.map((option) => ({ label: option.value, value: String(option.id) }))}
                value={selectedValues}
                onChange={onToggle}
            />
        </Stack>
    );
}
